export const formSectionsByFormat = {
  QPT: [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Core Bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Alistipes putredinis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides fragilis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Roseburia hominis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium breve', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium lactis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus helveticus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus thermophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Harmful Bacteria',
      inputs: [
        { label: 'Bacillus genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' },
        { label: 'Candida albicans', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' },
        { label: 'Clostridium difficile', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' },
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' },
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  '9P': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Core Bacteria',
      inputs: [
        { label: 'Bacteroides genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium breve', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium lactis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'Allergy and Skin': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Ruminococcus bromii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Candida albicans', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium lactis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'Allergy and Skin_kids': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QI' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Bacteroidetes phylum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Clostridium cluster IV', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Ruminococcus bromii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'Toxin': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Bacillus genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Candida albicans', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Clostridium difficile', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'oms': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Blautia genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Firmicutes phylum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Ruminococcus obeum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroidetes phylum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }, 
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },  
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },                    
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'bwcallergy': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'HN', type: 'text', placeholder: '1234ds4' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Candida albicans', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Ruminococcus bromii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium lactis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }, 
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },  
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },                    
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'bwccore': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'HN', type: 'text', placeholder: '1234ds4' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Alistipes putredinis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides fragilis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Clostridium cluster IV', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Enterococcus genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Roseburia hominis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Ruminococcus genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ],

  'bwcdiamond': [
    {
      title: 'Personal Information',
      inputs: [
        { label: 'Full Name', type: 'text', placeholder: 'Firstname Lastname' },
        { label: 'Gender', type: 'select', options: ['Select', 'Male', 'Female'] },
        { label: 'Date of Birth', type: 'date' },
        { label: 'Collection Date', type: 'date' },
        { label: 'HN', type: 'text', placeholder: '1234ds4' },
        { label: 'Report Date', type: 'date' },
        { label: 'Collection Kit Number', type: 'text', placeholder: '20230000' },
        { label: 'Report Number', type: 'text', placeholder: '20230000T1QPT' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Akkermansia muciniphila', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Alistipes putredinis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bacteroides fragilis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Faecalibacterium prausnitzii', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Roseburia hominis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Bacillus genus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Candida albicans', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Clostridium difficile', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Staphylococcus aureus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium bifidum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium breve', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium lactis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Bifidobacterium longum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus gasseri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus helveticus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus reuteri', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus thermophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ]
  ,

  'pet-care-essential': [
    {
      title: 'Personal Information',
      inputs: [
        { label: "Owner's name", type: 'text', placeholder: "Owner's name" },
        { label: 'petname', type: 'text', placeholder: 'Pet name' },
        { label: 'species_animal', type: 'select', options: ['Select', 'cat', 'dog'] },
        { label: 'health', type: 'text', placeholder: 'Health status' },
        { label: 'age', type: 'number', step: '1', placeholder: '0' },
        { label: 'breed', type: 'text', placeholder: 'Breed' },
        { label: 'collection_date', type: 'date' },
        { label: 'report_date', type: 'date' },
        { label: 'order_number', type: 'number', step: '1', placeholder: '0' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium infantis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Enterococcus faecium', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus thermophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Faecalibacterium', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Peptacetobacter hiranomis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    }
  ],

  'pet-care-pro': [
    {
      title: 'Personal Information',
      inputs: [
        { label: "Owner's name", type: 'text', placeholder: "Owner's name" },
        { label: 'petname', type: 'text', placeholder: 'Pet name' },
        { label: 'species_animal', type: 'select', options: ['Select', 'cat', 'dog'] },
        { label: 'health', type: 'text', placeholder: 'Health status' },
        { label: 'age', type: 'number', step: '1', placeholder: '0' },
        { label: 'breed', type: 'text', placeholder: 'Breed' },
        { label: 'collection_date', type: 'date' },
        { label: 'report_date', type: 'date' },
        { label: 'order_number', type: 'number', step: '1', placeholder: '0' }
      ]
    },
    {
      title: 'Probiotics',
      inputs: [
        { label: 'Bifidobacterium infantis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Enterococcus faecium', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus acidophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus paracasei', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus plantarum', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Lactobacillus rhamnosus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus thermophilus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Core bacteria',
      inputs: [
        { label: 'Faecalibacterium', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Peptacetobacter hiranomis', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Harmful bacteria',
      inputs: [
        { label: 'Escherichia coli', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' },
        { label: 'Streptococcus', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_color' }
      ]
    },
    {
      title: 'Universal',
      inputs: [
        { label: 'Universal bacteria', type: 'number', step: '0.01', placeholder: '0.00', formula: 'x', format: 'bar_colorlow' }
      ]
    }
  ]
};